// Dont misspell animations
export const Animations = Object.freeze({
    FadeInCenter: 'fade-in-center',
    FadeOutCenter: 'fade-out-center',

    FadeInLeft: 'fade-in-left',
    FadeInTop: 'fade-in-top',
    FadeInRight: 'fade-in-right',
    FadeInBottom: 'fade-in-bottom',
    FadeIn: 'fade-in',

    FadeOutLeft: 'fade-out-left',
    FadeOutTop: 'fade-out-top',
    FadeOutRight: 'fade-out-right',
    FadeOutBottom: 'fade-out-bottom',

    FadeOut: 'fade-out',
    Hidden: 'hidden',
    Visible: 'visible',
})

export default class Drawer {
    _name = ''
    _ref = null
    _triggers = []
    _animations = {}
    _visible = false

    constructor({ name, ref, animations, handleTrigger }) {
        this._name = name
        this._ref = ref
        this._animations = animations
        this._handleTrigger = handleTrigger
        
        this.setupTriggers()
    }

    toggleOpen() {
        if (this.visible) {
            this.visible = false;
        }

        if (!this.visible) {
            this.visible = true;
        }
    }

    addTrigger(element) {
        element.addEventListener('click', e => {
            // Stop click
            e.preventDefault()

            this._visible ? this.close() : this.open()
            this._handleTrigger({ name: this._name, visible: this._visible })
        })
    }

    setupTriggers() {
        const triggers = document.querySelectorAll(
            `[data-drawer-toggle="${this._name}"]`,
        )

        if (triggers && triggers.length) {
            triggers.forEach(trigger => {
                trigger.addEventListener('click', e => {
                    // Stop click
                    e.preventDefault()

                    this._visible ? this.close() : this.open()
                    this._handleTrigger({ name: this._name, visible: this._visible })

                })
            })
        }
    }

    open() {
        this._visible = true

        if (this._ref.classList.contains('hidden')) 
            this._ref.classList.remove('hidden');

        if (this._ref.classList.contains(this._animations.out)) 
            this._ref.classList.remove(this._animations.out)
        
        if (!this._ref.classList.contains(this._animations.in))
            this._ref.classList.add(this._animations.in)
        
    }

    close() {
        this._visible = false

        this._ref.classList.remove(this._animations.in)
        this._ref.classList.add(this._animations.out)
    }
}
